import { render, staticRenderFns } from "./SubTitleReport.vue?vue&type=template&id=02a0cfce&scoped=true"
import script from "./SubTitleReport.vue?vue&type=script&lang=js"
export * from "./SubTitleReport.vue?vue&type=script&lang=js"
import style0 from "./SubTitleReport.vue?vue&type=style&index=0&id=02a0cfce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a0cfce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02a0cfce')) {
      api.createRecord('02a0cfce', component.options)
    } else {
      api.reload('02a0cfce', component.options)
    }
    module.hot.accept("./SubTitleReport.vue?vue&type=template&id=02a0cfce&scoped=true", function () {
      api.rerender('02a0cfce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/SubTitleReport.vue"
export default component.exports